import React from 'react'
// eslint-disable-next-line import/no-extraneous-dependencies
import { Button } from 'baby-design'
import NiceModal from '@ebay/nice-modal-react'
import { ReturnInstructionsActionProps } from './ReturnInstructionsAction.types'
import ReturnInstructionsModal from '../../../ReturnInstructionsModal/ReturnInstructionsModal'

const ReturnInstructionsAction: React.FC<ReturnInstructionsActionProps> = ({
  reservation,
  returnInstructionsUrl,
}) => {
  const showReturnInstructionsModal = () => {
    if (!returnInstructionsUrl) {
      NiceModal.show(ReturnInstructionsModal, { reservation })
    }
  }

  return (
    <Button
      data-testid="GiftDetails__GiftActions__ReturnInstructions"
      href={returnInstructionsUrl}
      size="md"
      target="_blank"
      variant="tertiary"
      onClick={showReturnInstructionsModal}
    >
      Return instructions
    </Button>
  )
}

export default ReturnInstructionsAction
